import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { LocaleService } from './locale.service';

export const acceptLanguageInterceptor: HttpInterceptorFn = (req, next) => {
  const locale = inject(LocaleService).locale();
  return next(req.clone({ setHeaders: { 'Accept-Language': locale } }));
};
